<template>
  <div class="rce-page">
    <b-row>
      <!-- Progress -->
      <b-col cols="12">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <div class="d-flex align-items-center">
                <div class="rce-section-icon rce-icon-purple"><i class="fas fa-tasks"></i></div>
                <h5 class="rce-section-title mb-0">{{ msg('Progress').toUpperCase() }}</h5>
              </div>
              <div v-if="contract != null">
                <b-badge pill :variant="variantColorByProgress[progress]" class="rce-status-pill">
                  <template v-if="progress<100">
                    <i class="fas fa-clock-rotate-left mr-25"></i> {{ msg('In progress') }}
                  </template>
                  <template v-else>
                    <i class="fas fa-check mr-25"></i> {{ msg('Completed') }}
                  </template>
                  <i class="fas fa-greater-than mx-50" style="font-size:9px;opacity:.5"></i>
                  {{ msg(contract.status) }}
                </b-badge>
              </div>
            </div>
            <div v-if="contract != null">
              <b-progress height="10px" :variant="statusData(contract.status) != null ? statusData(contract.status).variant : 'primary'" :animated="statusData(contract.status) != null ? statusData(contract.status).animated : true" :value="progress" :max="100" class="rce-progress mb-2" />
              <b-row>
                <b-col cols="6" md="3">
                  <div class="rce-progress-card">
                    <div class="rce-progress-label">{{ msg("paid") }}</div>
                    <b-badge pill :variant="progressByKey['contract']<100?'danger':'success'">{{ progressByKey["contract"] }}%</b-badge>
                  </div>
                </b-col>
                <b-col cols="6" md="3">
                  <div class="rce-progress-card">
                    <div class="rce-progress-label">{{ msg("Passport") }}</div>
                    <b-badge pill :variant="progressByKey['passport']<100?'danger':'success'">{{ progressByKey["passport"] }}%</b-badge>
                  </div>
                </b-col>
                <b-col cols="6" md="3">
                  <div class="rce-progress-card">
                    <div class="rce-progress-label">{{ msg("Card Authorization") }}</div>
                    <b-badge pill :variant="progressByKey['deposit']<100?'danger':'success'">{{ progressByKey["deposit"] }}%</b-badge>
                  </div>
                </b-col>
                <b-col cols="6" md="3">
                  <div class="rce-progress-card">
                    <div class="rce-progress-label">{{ msg("signed") }}</div>
                    <b-badge pill :variant="progressByKey['signature']<100?'danger':'success'">{{ progressByKey["signature"] }}%</b-badge>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Property -->
      <b-col cols="12" xl="6">
        <div class="h-100 pb-2">
          <b-card no-body class="rce-card h-100">
            <b-card-body>
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="d-flex align-items-center">
                  <div class="rce-section-icon rce-icon-green"><i class="fas fa-home"></i></div>
                  <h5 class="rce-section-title mb-0">{{ msg('Property').toUpperCase() }}</h5>
                </div>
                <div v-if="contract != null">
                  <b-form-checkbox :disabled="!canEdit" v-model="approve.contract.property" @change="submitApproveStatus" class="rce-approve-check">{{ msg("Approved") }}</b-form-checkbox>
                </div>
              </div>
              <div v-if="property != null">
                <div class="rce-property-img-wrap mb-2">
                  <div class="w-100 image-cover" style="height: 280px; border-radius: 14px;" v-bind:style="{'background': `url(${imageSrc}) no-repeat center center / cover`}"/>
                </div>
                <div class="rce-info-table">
                  <div class="rce-info-row">
                    <span class="rce-info-key"><i class="fas fa-tag mr-50"></i> Id</span>
                    <span class="rce-info-val">{{ property.id }}</span>
                  </div>
                  <div class="rce-info-row">
                    <span class="rce-info-key"><i class="fas fa-map-marker-alt mr-50"></i> {{ msg("Address") }}</span>
                    <span class="rce-info-val">{{ property.address }} {{ property.house }}, {{ property.city }}, {{ property.country }}</span>
                  </div>
                  <div class="rce-info-row" v-if="property.realEstateTreasure!=null">
                    <span class="rce-info-key"><i class="fas fa-sign-in-alt mr-50"></i> {{ msg("Details") }}</span>
                    <span class="rce-info-val">
                      <div class="max-lines-2" v-if="!showFullText">{{ property.realEstateTreasure.keyCode }}</div>
                      <div v-else>{{ property.realEstateTreasure.keyCode }} {{ property.realEstateTreasure.additionalInfo }}</div>
                      <a href="#" class="rce-read-more" @click.prevent="toggleText">{{ showFullText ? msg('Read less') : msg('Read more') }}</a>
                    </span>
                  </div>
                </div>
                <div class="rce-action-grid mt-2">
                  <b-button variant="outline-warning" size="sm" class="rce-action-btn" @click="generateAndSendLinkButton">
                    <i class="fas fa-link mr-50"></i> {{ msg("Send platform link and credentials to client") }}
                  </b-button>
                  <b-button variant="outline-warning" size="sm" class="rce-action-btn" @click="sendCheckInDetailsButton">
                    <i class="fas fa-key mr-50"></i> {{ msg("Send CheckIn details to client") }}
                  </b-button>
                  <b-button variant="outline-primary" size="sm" class="rce-action-btn" @click="openSmsDialog">
                    <i class="fas fa-sms mr-50"></i> SMS
                  </b-button>
                  <b-button variant="outline-primary" size="sm" class="rce-action-btn" @click="openInvoicePage">
                    <i class="fas fa-file-invoice mr-50"></i> {{ msg('Go to invoice') }}
                  </b-button>
                  <b-button variant="outline-primary" size="sm" class="rce-action-btn" @click="openCleaningProgressPage">
                    <i class="fas fa-broom mr-50"></i> {{ msg('Go to cleaning progress') }}
                  </b-button>
                  <b-button variant="outline-primary" size="sm" class="rce-action-btn" @click="openOverlappedBookingsModal">
                    <i class="fas fa-layer-group mr-50"></i> {{ msg('Overlapped bookings') }}
                  </b-button>
                </div>
                <b-modal id="overlappedBookingsModal" :title="msg('Overlapped Bookings')" hide-footer centered size="md">
                  <div>
                    <p v-if="!contract || !contract.overBookedContracts || Object.keys(contract.overBookedContracts).length === 0" class="text-muted text-center py-2">
                      {{ msg('No overlapped bookings') }}
                    </p>
                    <ul v-else class="rce-overlap-list">
                      <li v-for="(clientName, id) in contract.overBookedContracts" :key="id" class="rce-overlap-item">
                        <span class="font-weight-bold">{{ clientName }}</span>
                        <b-button variant="primary" size="sm" class="rce-btn-sm" @click.prevent="goToContract(id)">
                          <i class="fas fa-external-link-alt mr-25"></i> {{ msg('redirecttocontract') }}
                        </b-button>
                      </li>
                    </ul>
                    <b-button variant="secondary" class="mt-2 w-100 rce-btn-sm" @click="$bvModal.hide('overlappedBookingsModal')">
                      {{ msg('Close') }}
                    </b-button>
                  </div>
                </b-modal>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-col>

      <!-- Client -->
      <b-col cols="12" xl="6">
        <div class="h-100 pb-2">
          <b-card no-body class="rce-card h-100">
            <b-card-body>
              <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <div class="d-flex align-items-center">
                  <div class="rce-section-icon rce-icon-blue"><i class="fas fa-user"></i></div>
                  <h5 class="rce-section-title mb-0">{{ msg('Client').toUpperCase() }}</h5>
                </div>
                <div v-if="contract != null" class="d-flex align-items-center" style="gap:10px">
                  <b-form-checkbox class="rce-approve-check" v-bind:disabled="!canEdit || approve.contract.client === true" v-model="editableFields.client" @change="submitUpdateEditable">
                    <span v-bind:title="msg('ClientCanUpdate')" v-b-tooltip>{{ msg("Editable") }}</span>
                  </b-form-checkbox>
                  <b-form-checkbox class="rce-approve-check" :disabled="!canEdit || editableFields.client === true" v-model="approve.contract.client" @change="submitApproveStatus">{{ msg("Approved") }}</b-form-checkbox>
                </div>
              </div>
              <div v-if="contract != null">
                <app-collapse accordion type="margin">
                  <app-collapse-item :title="msg('Profile - Client details for the contract')" is-visible>
                    <div class="rce-info-table">
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-tag mr-50"></i> Id</span>
                        <span class="rce-info-val">{{ client.id }} <b-button size="sm" variant="link" @click="openClientAccount"><i class="fa-solid fa-right-to-bracket"></i></b-button></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Register date") }}</span>
                        <span class="rce-info-val">{{ client.creationTime }}</span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Firstname") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.firstname" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Lastname") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.lastname" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-birthday-cake mr-50"></i> {{ msg("Birthday") }}</span>
                        <span class="rce-info-val"><calendar-picker v-model="contract.client.birthday" mode="date" :max-date="$moment().subtract(18, 'year').toDate()"/></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-at mr-50"></i> {{ msg("Contract Email") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.email" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-at mr-50"></i> {{ msg("Client Email") }}</span>
                        <span class="rce-info-val" style="font-size:12px">{{ client.email }}</span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-phone-alt mr-50"></i> {{ msg("Phone") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="client.phone" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("address") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.address.street" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("city") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.address.city" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Zip") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.address.zip" class="rce-inline-input" /></span>
                      </div>
                      <div class="rce-info-row">
                        <span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("country") }}</span>
                        <span class="rce-info-val"><b-form-input size="sm" v-model="contract.client.address.country" class="rce-inline-input" /></span>
                      </div>
                    </div>
                  </app-collapse-item>
                  <app-collapse-item title="Job">
                    <div class="rce-info-table">
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-suitcase mr-50"></i> {{ msg("Job Title") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.income.jobTitle" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.income.companyName" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company street") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.income.companyAddress.street" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company city") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.income.companyAddress.city" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Company country") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.income.companyAddress.country" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-file-invoice mr-50"></i> {{ msg("Netto income") }}</span><span class="rce-info-val"><b-form-input size="sm" type="number" v-model="contract.income.net" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-user-clock mr-50"></i> {{ msg("Seniority") }}</span><span class="rce-info-val"><b-form-input size="sm" type="number" v-model="contract.income.seniority" class="rce-inline-input" /></span></div>
                    </div>
                  </app-collapse-item>
                  <app-collapse-item v-if="contract.card!=null" title="Card">
                    <div class="rce-info-table">
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-credit-card mr-50"></i> {{ msg("Name") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.card.name" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-hashtag mr-50"></i> {{ msg("Number") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.card.number" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-calendar mr-50"></i> {{ msg("Date") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.card.date" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-lock mr-50"></i> {{ msg("Cvv") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contract.card.cvv" class="rce-inline-input" /></span></div>
                    </div>
                  </app-collapse-item>
                  <app-collapse-item :title="'KSV'">
                    <div class="rce-info-table">
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-file-invoice mr-50"></i> {{ msg("Inkasso open") }}</span><span class="rce-info-val"><b-form-checkbox v-model="ksv.inkasso" :value="true" :unchecked-value="false" disabled /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-exclamation-triangle mr-50"></i> {{ msg("Insolvency") }}</span><span class="rce-info-val"><b-form-checkbox v-model="ksv.insolvency" :value="true" disabled :unchecked-value="false" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key">{{ msg("Commercial Functions") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="ksv.commercialFunctions" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key">{{ msg("Land register") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="ksv.landRegister" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key">{{ msg("Open loans") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="ksv.openLoans" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key">{{ msg("Company participations") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="ksv.companyParticipations" class="rce-inline-input" /></span></div>
                      <div class="rce-info-row"><span class="rce-info-key">{{ msg("KSV Score") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="ksv.ksvScore" class="rce-inline-input" /></span></div>
                    </div>
                    <div class="mt-1">
                      <template v-if="ksv.status==null || ksv.status==='NOT APPLIED YET'">
                        <b-button variant="outline-warning" size="sm" class="rce-btn-sm" @click="createOrFetchKsvData">{{ msg("Apply for KSV data (6€/Request)") }}</b-button>
                      </template>
                      <template v-else-if="ksv.status==='APPLICATIONCREATED'">
                        <b-button disabled variant="outline-warning" size="sm" class="rce-btn-sm">{{ msg("Successfully applied please wait") }}</b-button>
                      </template>
                      <template v-else>
                        <b-button disabled variant="outline-success" size="sm" class="rce-btn-sm">{{ msg("Data fetched successfully") }}</b-button>
                      </template>
                    </div>
                  </app-collapse-item>
                </app-collapse>
                <div class="text-right mt-2">
                  <b-button variant="primary" size="sm" class="rce-btn-sm" @click="submitContract"><i class="fas fa-save mr-50"></i> {{ msg("Update") }}</b-button>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-col>

      <!-- Contract -->
      <b-col cols="12" xl="6">
        <div class="h-100 pb-2">
          <b-card no-body class="rce-card h-100">
            <b-card-body>
              <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <div class="d-flex align-items-center">
                  <div class="rce-section-icon rce-icon-orange"><i class="fas fa-file-alt"></i></div>
                  <h5 class="rce-section-title mb-0">{{ msg('Contract').toUpperCase() }}</h5>
                </div>
                <div v-if="contract != null" class="d-flex align-items-center" style="gap:10px">
                  <b-form-checkbox class="rce-approve-check" v-bind:disabled="!canEdit || approve.contract.contractData === true" v-model="editableFields.contract" @change="submitUpdateEditable">
                    <span v-bind:title="msg('ClientCanUpdate')" v-b-tooltip>{{ msg("Editable") }}</span>
                  </b-form-checkbox>
                  <b-form-checkbox class="rce-approve-check" :disabled="!canEdit || editableFields.contract === true" v-model="approve.contract.contractData" @change="submitApproveStatus">{{ msg("Approved") }}</b-form-checkbox>
                </div>
              </div>
              <b-modal v-model="cancelModal.show" :id="cancelModal.id" :title="msg('Confirmation')" @ok="cancelContractById()" ok-variant="danger" :cancel-title="msg('cancel')" @hide="resetCancelModal">
                <p class="my-4">{{ msg('areyousureyouwanttocancelthiscontract') }}</p>
              </b-modal>
              <b-modal v-model="changeModal.show" :id="changeModal.id" :title="msg('Confirmation')" @ok="changeContractById()" :ok-disabled="newPropertyId == null || hostawayApi == null" ok-variant="danger" :cancel-title="msg('cancel')" @hide="resetChangeModal">
                <b-col cols="12">
                  <b-form-group :label="msg('Export contract to channels')">
                    <b-form-checkbox v-model="hostawayApi" switch>{{ hostawayApi ? msg('Yes') : msg('No') }}</b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="msg('searchimmofornewcontract')">
                    <real-estate-picker v-model="newPropertyId"/>
                  </b-form-group>
                </b-col>
                <p class="my-4">{{ msg('areyousureyouwanttochangethiscontract') }}</p>
              </b-modal>
              <b-modal v-model="pdfModal.show" :id="pdfModal.id" :title="msg('Confirmation PDF INVOICE')" @ok="generatePdfInvoice()" ok-variant="danger" :cancel-title="msg('cancel')" @hide="resetPdfModal">
                <p class="my-4">{{ msg('test pdf') }}</p>
              </b-modal>
              <sign-offer ref="sign-offer" v-if="contract != null" v-bind:contract="contract" />
              <div v-if="contract != null" class="rce-info-table">
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-tag mr-50"></i> Id</span><span class="rce-info-val">{{ contract.id }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-tag mr-50"></i> External Id</span><span class="rce-info-val">{{ contract.hostawayReservationId }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-tag mr-50"></i> Platform Id</span><span class="rce-info-val">{{ contract.platformReservationId }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Register date") }}</span><span class="rce-info-val">{{ $moment(contract.creationTime).format("DD/MM/yy HH:mm") }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Client") }}</span><span class="rce-info-val text-capitalize"><b-link @click="()=>$root.$emit('crm::client::select',client.id)">{{ contract.client.firstname }} {{ contract.client.lastname }}</b-link> <span v-if="contract.client.birthday != null">({{ $moment().diff(contract.client.birthday, 'years') }})</span></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-home mr-50"></i> {{ msg("Property") }}</span><span class="rce-info-val">{{ property.address }} {{ property.house }}, {{ property.city }}, {{ property.country }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-clipboard mr-50"></i> {{ msg("Usage") }}</span><span class="rce-info-val">{{ contract.use }}</span></div>
                <div class="rce-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="rce-info-key"><i class="fas fa-globe mr-50"></i> {{ msg("Platform") }}</span><span class="rce-info-val">{{ contractEdit.bnbStyleRent.platform }}</span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Landlord Firstname") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.landlord.firstname" class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-user mr-50"></i> {{ msg("Landlord Lastname") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.landlord.lastname" class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-birthday-cake mr-50"></i> {{ msg("Landlord") }} {{ msg("Birthday") }}</span><span class="rce-info-val"><calendar-picker disabled v-model="contractEdit.landlord.dateOfbirth" mode="date" :max-date="$moment().subtract(18, 'year').toDate()"/></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-map-marker-alt mr-50"></i> {{ msg("Landlord") }} {{ msg("Address") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.landlord.fullAddress" class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-phone-alt mr-50"></i> {{ msg("Landlord") }} {{ msg("Phone") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.landlord.phone" class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-university mr-50"></i> {{ msg("Landlord") }} {{ msg("Iban") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.landlord.iban" class="rce-inline-input" /></span></div>
                <div class="rce-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="rce-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("Period price") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.bnbStyleRent.totalPayment" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="rce-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("periodpriceafterdis") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.bnbStyleRent.totalPaymentDiscount" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="rce-info-key"><i class="fas fa-moon mr-50"></i> {{ msg("TotalNights") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.bnbStyleRent.totalNights" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row" v-if="contract.bnbStyleRent!=null&&contract.bnbStyleRent.active"><span class="rce-info-key"><i class="fas fa-users mr-50"></i> {{ msg("Guests") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.numberOfGuests" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-money-check-alt mr-50"></i> {{ msg("Platform commision") }}</span><span class="rce-info-val"><b-form-input size="sm" v-model="contractEdit.bnbStyleRent.commissionAmount" number readonly class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fa-solid fa-money-bill-transfer mr-50"></i> {{ msg("Payment Processing Fee") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="contractEdit.bnbStyleRent.paymentProcessingFee" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("Move Date") }}</span><span class="rce-info-val"><calendar-picker disabled v-model="contractEdit.moveDate"/></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fas fa-calendar-day mr-50"></i> {{ msg("CheckOut") }}</span><span class="rce-info-val"><calendar-picker disabled v-model="contractEdit.endDate"/></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fa-solid fa-money-bill-transfer mr-50"></i> {{ msg("Deposit") }}</span><span class="rce-info-val"><b-form-input size="sm" readonly v-model="computedDeposit" number class="rce-inline-input" /></span></div>
                <div class="rce-info-row"><span class="rce-info-key"><i class="fa-solid fa-cancel mr-50"></i> {{ msg("Cancellation policy") }}</span><span class="rce-info-val">{{ contractEdit.cancelationOptionPicked != null ? msg(contractEdit.cancelationOptionPicked) : msg('nonRefundable') }}</span></div>
              </div>
              <div class="d-flex justify-content-between mt-2">
                <b-button variant="outline-warning" size="sm" class="rce-btn-sm" @click="setContractEdit"><i class="fas fa-undo mr-50"></i> {{ msg("Reset") }}</b-button>
                <b-button variant="primary" size="sm" class="rce-btn-sm" @click="submitContract"><i class="fas fa-save mr-50"></i> {{ msg("Update") }}</b-button>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-col>

      <!-- Timeline -->
      <b-col cols="12" xl="6">
        <div class="h-100 pb-2">
          <b-card no-body class="rce-card h-100" ref="add-status-histories">
            <b-card-body>
              <div class="d-flex align-items-center mb-2">
                <div class="rce-section-icon rce-icon-teal"><i class="fas fa-clock"></i></div>
                <h5 class="rce-section-title mb-0">{{ msg('Time line').toUpperCase() }}</h5>
              </div>
              <div v-if="contract != null">
                <perfect-scrollbar class="position-relative" style="height: 300px" :options="{maxScrollbarLength:100}">
                  <app-timeline v-for="(statusHistory,index) in contract.statusHistories" v-bind:key="index">
                    <app-timeline-item class="mb-2" is-title :title="msg(statusHistory.status)" :time="statusHistory.time | moment('DD/MM/YY HH:mm:ss')" :variant="statusData(statusHistory.status).variant">
                      <template v-slot:subtitle>
                        <p class="text-muted text-capitalize" style="font-size:12px;line-height:10px" v-if="statusHistory.source != null">
                          {{ (statusHistory.source || "").toLowerCase() }}
                          {{ statusHistory.userId > 0 ? `: ${getUserFullName(statusHistory.userId)}` : '' }}
                        </p>
                        <p class="m-0">{{ statusHistory.note }}</p>
                      </template>
                    </app-timeline-item>
                  </app-timeline>
                </perfect-scrollbar>
                <div class="rce-info-table mt-2">
                  <div class="rce-info-row">
                    <span class="rce-info-key"><i class="fas fa-step-forward mr-50"></i> {{ msg("Step") }}</span>
                    <span class="rce-info-val">
                      <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="newHistory.step" v-bind:options="contractSteps" class="w-100 select-size-sm rce-select" label="name" :reduce="(s) => s.value" :selectable="s => s.active" autocomplete="on" :clearable="false" style="min-width:130px" size="sm" @input="onStepChange">
                        <template #selected-option="step"><i v-bind:class="[step.icon]" class="mr-1"></i> {{ msg(step.name) }}</template>
                        <template #option="step"><i v-bind:class="[step.icon]" class="mr-1"></i> {{ msg(step.name) }}</template>
                      </v-select>
                    </span>
                  </div>
                  <div class="rce-info-row">
                    <span class="rce-info-key"><i class="fas fa-bookmark mr-50"></i> {{ msg("Status") }}</span>
                    <span class="rce-info-val">
                      <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="newHistory.status" v-bind:options="contractsStatus" class="w-100 select-size-sm rce-select" label="label" :reduce="(s) => s.label" :selectable="s => s.active" autocomplete="on" :clearable="false" style="min-width:130px" size="sm" />
                    </span>
                  </div>
                  <div class="rce-info-row" style="align-items:flex-start">
                    <span class="rce-info-key"><i class="fas fa-sticky-note mr-50"></i> {{ msg("Note") }}</span>
                    <span class="rce-info-val">
                      <b-form-textarea v-model="newHistory.note" class="rce-inline-input" rows="2"></b-form-textarea>
                      <div class="d-flex mt-50" style="gap:12px">
                        <b-form-checkbox v-model="newHistory.visibleToClient" switch size="sm">{{ msg("Visible to client") }}</b-form-checkbox>
                        <b-form-checkbox v-model="newHistory.visibleToOwner" switch size="sm">{{ msg("Visible to owner") }}</b-form-checkbox>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                  <b-button variant="outline-warning" size="sm" class="rce-btn-sm" @click="resetNewHistory"><i class="fas fa-undo mr-50"></i> {{ msg("Reset") }}</b-button>
                  <b-button variant="primary" size="sm" class="rce-btn-sm" @click="submitStatus"><i class="fas fa-save mr-50"></i> {{ msg("Update") }}</b-button>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-col>

      <!-- Locker -->
      <b-col cols="12" id="locker-actions">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <div class="d-flex align-items-center">
                <div class="rce-section-icon rce-icon-blue"><i class="fas fa-lock"></i></div>
                <h5 class="rce-section-title mb-0">{{ msg('Locker Actions') }}</h5>
              </div>
              <div class="d-flex align-items-center" style="gap:10px">
                <b-button variant="link" class="rce-icon-btn" v-b-tooltip :title="msg('Refresh locker status')" @click="refreshLockerStatus"><i class="fa-solid fa-rotate"></i></b-button>
                <b-badge :variant="currentStatusVariant" pill class="rce-status-pill"><i :class="currentStatusIcon" class="mr-25"></i> {{ currentStatusLabel }}</b-badge>
                <span v-if="keyBoxStatus && keyBoxStatus.msg" class="small text-muted">{{ keyBoxStatus.msg }}</span>
              </div>
            </div>
            <div class="text-center mb-2">
              <div class="rce-label mb-50">{{ msg('Assigned Compartment') }}</div>
              <b-badge v-if="contract && contract.lockerCompartment != null" variant="info" pill class="px-3 py-50 font-weight-bold">#{{ contract.lockerCompartment }}</b-badge>
              <b-badge v-else variant="secondary" pill class="px-3 py-50 font-weight-bold">{{ msg('No compartment assigned') }}</b-badge>
            </div>
            <div v-if="contract && contract.lockerCompartment != null" class="text-center mb-2">
              <div class="rce-label mb-50">{{ msg('Access Status') }}</div>
              <b-badge :variant="isAccessDenied ? 'danger' : 'success'" pill class="px-3 py-50 font-weight-bold">{{ isAccessDenied ? msg('Access Denied') : msg('Access Allowed') }}</b-badge>
            </div>
            <div class="text-center">
              <b-button variant="outline-success" class="rce-btn-sm mr-1" :disabled="!contract || contract.lockerCompartment == null" @click="openLocker"><i class="fa-solid fa-lock-open mr-50"></i> {{ msg('Open Now') }}</b-button>
              <b-button :variant="isAccessDenied ? 'outline-success' : 'outline-danger'" class="rce-btn-sm" :disabled="!contract || contract.lockerCompartment == null" @click="toggleAccess(isAccessDenied ? 'grant' : 'deny')"><i :class="isAccessDenied ? 'fa-solid fa-user-check mr-50' : 'fa-solid fa-ban mr-50'"></i> {{ isAccessDenied ? msg('Give Access') : msg('Deny Access') }}</b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Guest Feature -->
      <b-col cols="12" id="guest-feature">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="d-flex align-items-center">
                <div class="rce-section-icon rce-icon-orange"><i class="fas fa-shopping-bag"></i></div>
                <h5 class="rce-section-title mb-0">{{ msg('Guest Feature') }}</h5>
              </div>
              <div style="display:flex;gap:6px">
                <b-button variant="link" class="rce-icon-btn" @click="()=>$refs.contractFeature.makeOrder()"><i class="fa-solid fa-cash-register"></i></b-button>
                <b-button variant="link" class="rce-icon-btn" @click="()=>$refs.contractFeature.addNew()"><i class="fa-solid fa-plus"></i></b-button>
                <b-button variant="link" class="rce-icon-btn" @click="()=>$refs.contractFeature.refresh()"><i class="fa-solid fa-arrows-rotate"></i></b-button>
              </div>
            </div>
            <real-estate-contract-feature ref="contractFeature" v-bind:contract-id="id"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Hostaway Chat -->
      <b-col cols="12" v-if="contract != null">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex align-items-center mb-2">
              <div class="rce-section-icon rce-icon-purple"><i class="fas fa-paper-plane"></i></div>
              <h5 class="rce-section-title mb-0">{{ (contract.bnbStyleRent != null && contract.bnbStyleRent.platform != null) ? (msg(contract.bnbStyleRent.platform).toUpperCase() + ' CHAT') : 'EXTERNAL CHAT' }}</h5>
            </div>
            <hostaway-chat-component v-bind:contractId="id" v-bind:reservation-id="contract.hostawayReservationId" v-bind:contract="contract"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- WhatsApp Chat -->
      <b-col cols="12" v-if="contract != null">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex align-items-center mb-2">
              <div class="rce-section-icon rce-icon-green"><i class="fab fa-whatsapp"></i></div>
              <h5 class="rce-section-title mb-0">WHATSAPP CHAT</h5>
            </div>
            <whatsapp-chat-component v-bind:clientId="contract.clientId" v-bind:whatsapp="contract.whatsappChat"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Message Template History -->
      <b-col cols="12" v-if="contract != null">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex align-items-center mb-2">
              <div class="rce-section-icon rce-icon-teal"><i class="fas fa-history"></i></div>
              <h5 class="rce-section-title mb-0">Message Template History</h5>
            </div>
            <message-template-history-component @refresh="refresh" v-bind:history="contract.messageTemplateHistory" :contract-id="contract.id"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Payments -->
      <b-col cols="12" v-if="contract != null">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <div class="d-flex align-items-center">
                <div class="rce-section-icon rce-icon-green"><i class="fas fa-money-bill"></i></div>
                <h5 class="rce-section-title mb-0">PAYMENTS</h5>
              </div>
              <div class="d-flex align-items-center" style="gap:12px">
                <b-form-checkbox v-model="contract.depositPaid" @change="depositPaid('Deposit Paid', contract.depositPaid)">Deposit Paid</b-form-checkbox>
                <b-form-checkbox v-model="contract.depositRefunded" @change="depositRefunded('Deposit Refunded', contract.depositRefunded)">Deposit Refunded</b-form-checkbox>
                <b-button variant="warning" size="sm" class="rce-btn-sm" @click="openPaymentModal"><i class="fas fa-credit-card mr-50"></i> {{ msg('Make payment') }}</b-button>
              </div>
            </div>
            <payment-client-table @submitted="refresh" :payments="contract.clientPayments" :contract-id="contract.id"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Damages -->
      <b-col cols="12">
        <contract-damage-component v-bind:contract-id="id"/>
      </b-col>

      <!-- Alerts -->
      <b-col cols="12">
        <b-card no-body class="rce-card">
          <b-card-body>
            <div class="d-flex align-items-center mb-2">
              <div class="rce-section-icon" style="background:rgba(234,84,85,.12);color:#ea5455"><i class="fas fa-exclamation-circle"></i></div>
              <h5 class="rce-section-title mb-0">{{ msg('Alerts').toUpperCase() }}</h5>
            </div>
            <contract-alert-component ref="alertComponent" v-bind:contractId="id"/>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Files -->
      <b-col cols="12">
        <b-card no-body class="rce-card" style="min-height:550px">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="d-flex align-items-center">
                <div class="rce-section-icon rce-icon-blue"><i class="fas fa-folder-open"></i></div>
                <h5 class="rce-section-title mb-0">{{ msg('Files').toUpperCase() }}</h5>
              </div>
              <div v-if="contract != null">
                <b-button size="sm" :variant="uploadFile ? 'warning' : 'outline-warning'" class="rce-btn-sm" @click="()=>uploadFile=!uploadFile">
                  <i class="fas fa-upload mr-50"></i> {{ msg("Upload file") }}
                </b-button>
              </div>
            </div>
            <div v-if="contract != null">
              <b-alert show class="p-1 rce-file-warning" variant="secondary">
                <i class="fas fa-exclamation-circle text-danger mr-50"></i>
                {{ msg('Be careful with the client files, some files can contain viruses. Do not open any link in the file') }}
              </b-alert>
              <div class="mb-2">
                <div class="rce-label mb-50">{{ msg("File status") }}</div>
                <b-form-group>
                  <b-form-checkbox :disabled="!canEdit" inline v-model="approve.document.photo" @change="submitApproveStatus">{{ msg("Photo ID") }}</b-form-checkbox>
                  <b-form-checkbox :disabled="!canEdit" inline v-model="approve.document.document" @change="submitApproveStatus">{{ msg("Client Document") }}</b-form-checkbox>
                  <b-form-checkbox :disabled="!canEdit" inline v-model="approve.document.income" @change="submitApproveStatus">{{ msg("Income") }}</b-form-checkbox>
                  <b-form-checkbox :disabled="!canEdit" inline v-model="approve.document.contract" @change="submitApproveStatus">{{ msg("Approved contract") }}</b-form-checkbox>
                </b-form-group>
              </div>
              <div class="rce-label mb-50">{{ msg("All files") }}</div>
              <div class="files-data">
                <div class="upload-backdrop" v-show="uploadFile === true">
                  <vue-dropzone id="contract-upload" class="h-100" :options="dropzoneOptions" :useCustomSlot=true :duplicateCheck="true" @vdropzone-complete="uploadComplete" @vdropzone-success="uploadSuccess">
                    <div class="dropzone-custom-content">
                      <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                      <div class="subtitle">...or click to select a file from your computer</div>
                    </div>
                  </vue-dropzone>
                </div>
                <b-table-simple outlined class="rce-files-table">
                  <b-tr>
                    <b-th style="width:20%">{{ msg('File') }}</b-th>
                    <b-th style="width:20%">{{ msg('Tag') }}</b-th>
                    <b-th style="width:20%">{{ msg('Client note') }}</b-th>
                    <b-th style="width:20%">{{ msg('Note') }}</b-th>
                    <b-th style="width:10%">{{ msg("Visible") }}</b-th>
                    <b-th style="width:15%">{{ msg('Operations') }}</b-th>
                  </b-tr>
                </b-table-simple>
                <perfect-scrollbar class="position-relative" style="height:250px">
                  <b-table-simple outlined>
                    <b-tr v-for="(file,index) in (contract.files || [])" v-bind:key="file.id" style="white-space:nowrap;text-overflow:ellipsis" v-show="file.active">
                      <b-td style="width:20%"><i v-bind:class="iconByExt(file.filename)" class="mx-1" style="font-size:20px"></i>{{ file.filename }}</b-td>
                      <b-td class="text-center" style="width:20%">
                        <v-select :options="fileTags" :reduce="(t) => t.value" label="title" v-model="file.tag" append-to-body @input="()=>submitDocumentFile(index)">
                          <template v-slot:option="option"><i class="d-inline-block text-left" style="width:30px" :class="option.icon"></i><span>{{ option.title }}</span></template>
                        </v-select>
                      </b-td>
                      <b-td class="text-center" style="width:20%"><b-form-textarea v-model="file.clientNote" @change="()=>submitDocumentFile(index)" size="sm"></b-form-textarea></b-td>
                      <b-td class="text-center" style="width:20%"><b-form-textarea v-model="file.notes" @change="()=>submitDocumentFile(index)" size="sm"></b-form-textarea></b-td>
                      <b-td class="text-center" style="width:10%">
                        <b-form-checkbox v-model="file.visible" class="mx-1" size="sm" @change="()=>submitDocumentFile(index)" v-b-tooltip="msg('visible to client')" button v-bind:button-variant="file.visible ? 'outline-success' : 'outline-warning'"><i class="fas fa-user"></i></b-form-checkbox>
                        <b-form-checkbox v-model="file.visibleForOwner" size="sm" @change="()=>submitDocumentFile(index)" v-b-tooltip="msg('visible to owner')" button v-bind:button-variant="file.visibleForOwner ? 'outline-success' : 'outline-warning'"><i class="fas fa-user-tie"></i></b-form-checkbox>
                      </b-td>
                      <b-td class="text-center" style="width:15%">
                        <b-link class="text-secondary mx-1" @click="()=>onHideFile(index)"><i class="fas fa-eye-slash"></i></b-link>
                        <b-link><i class="fas fa-download" @click="()=>onDownloadFile(file.id)"></i></b-link>
                      </b-td>
                    </b-tr>
                  </b-table-simple>
                </perfect-scrollbar>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <contract-generator-component ref="contractGenerator" v-model="contract" @contractSigned="refresh" />

    <b-modal no-fade v-model="dialogs.sms" size="l" ref="sms-modal" id="sms-modal" :hide-footer="true" no-close-on-backdrop centered>
      <sms-panel ref="smsPanel" @submitted="onSubmitted" :client-id="client.id"/>
      <div class="mt-2 text-center">
        <b-button variant="primary" class="rce-btn-sm" @click="submitSMS"><i class="fas fa-paper-plane mr-50"></i> {{ msg('Send SMS') }}</b-button>
      </div>
    </b-modal>

    <b-modal v-if="contract != null" no-fade v-model="dialogs.payment" size="l" ref="payment-modal" id="payment-modal" :hide-footer="true" :title="'Customer: ' + contract.client.lastname + ' ' + contract.client.firstname + ' - Stripe Payment'" no-close-on-backdrop centered>
      <div class="mt-2 text-center">
        <label class="rce-label">{{ msg("Type") }}</label>
        <v-select v-model="paymentType" class="mb-2 rce-select" :clearable="false" :options="paymentOptions" label="label" :reduce="(b) => b.value" placeholder="Select payment type"></v-select>
        <div v-if="paymentType === 'Credit card'">
          <label class="rce-label">{{ msg("Reason") }}</label>
          <b-form-input v-model="reason" class="mb-2 rce-inline-input"></b-form-input>
          <label class="rce-label">{{ msg("Amount") }}</label>
          <b-form-input v-model="paymentAmount" type="number" step="0.01" min="0" max="3000" class="mb-2 rce-inline-input"></b-form-input>
          <b-button :disabled="paymentAmount == null || paymentAmount <= 0.0 || paymentLoading || reason == null" variant="success" class="rce-btn-sm" @click="makePayment"><i class="fas fa-bolt mr-50"></i> {{ msg('Charge the customer now') }}</b-button>
        </div>
        <div v-else-if="paymentType === 'Cash' || paymentType === 'Wire transfer'">
          <label class="rce-label">{{ msg("Reason") }}</label>
          <b-form-input v-model="reason" class="mb-2 rce-inline-input"></b-form-input>
          <label class="rce-label">{{ msg("Amount") }}</label>
          <b-form-input v-model="paymentAmount" type="number" step="0.01" min="0" class="mb-2 rce-inline-input"></b-form-input>
          <b-form-checkbox class="mb-2" v-model="isPaid" switch>{{ isPaid ? msg("Paid") : msg("Not paid") }}</b-form-checkbox>
          <b-form-datepicker v-model="paymentDate" :min="minDate" placeholder="Select date" class="mb-2"></b-form-datepicker>
          <b-button :disabled="!paymentDate || paymentAmount == null || paymentAmount <= 0.0 || paymentLoading || reason == null" variant="success" class="rce-btn-sm" @click="makePayment"><i class="fas fa-check mr-50"></i> {{ msg('Confirm Payment') }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import vue2Dropzone from 'vue2-dropzone'
import VueSlider from 'vue-slider-component'
import ContractGeneratorComponent from "@/views/realEstate/contracts/contractGeneratorComponent";
import ContractAlertComponent from "@/views/realEstate/contracts/ContractAlertComponent";
import signOffer from "@/views/realEstate/contracts/signOffer";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker";
import HostawayChatComponent from "@/views/realEstate/contracts/HostawayChatComponent";
import WhatsappChatComponent from "@/views/realEstate/contracts/WhatsappChatComponent";
import PaymentClientTable from "@/views/realEstate/contracts/paymentClientTable";
import SmsPanel from "@/components/panels/client/smsPanel.vue";
import ContractDamageComponent from "@/views/realEstate/contracts/ContractDamageComponent.vue";
import MessageTemplateHistoryComponent from "@/views/realEstate/contracts/MessageTemplateHistoryComponent.vue";
import RealEstateContractFeature from "@/components/components/realEstate/contracts/realEstateContractFeature.vue";

export default {
  name: "RealEstateRentContractEdit",
  components: {
    RealEstateContractFeature,
    MessageTemplateHistoryComponent,
    ContractDamageComponent,
    SmsPanel,
    ContractAlertComponent,
    ContractGeneratorComponent,
    AppCollapse,
    PaymentClientTable,
    RealEstatePicker,
    HostawayChatComponent,
    WhatsappChatComponent,
    AppCollapseItem,
    signOffer,
    AppTimeline,
    AppTimelineItem,
    // eslint-disable-next-line vue/no-unused-components
    VueSlider,
    vueDropzone: vue2Dropzone,
  },
  data: () => ({
    id: null,
    value: 50,
    contract: null,
    newPropertyId: null,
    hostawayApi: false,
    currentStatus: 'checking',
    permissions: {},
    keyBoxStatus: {},
    alerts: [],
    locker: { assigned: false, number: null, open: false },
    cancelModal: { id: 'cancel-modal', title: '', content: '', show: false },
    changeModal: { id: 'change-modal', title: '', content: '', show: false },
    pdfModal: { id: 'pdf-modal', title: '', content: '', show: false },
    showFullText: false,
    allContractStatus: [],
    allContractSteps: {},
    ksv: {status: "NOT APPLIED YET"},
    contractEdit: {price: 0, provision: null, moveDate: 0, endDate: null, landlord: {}},
    approve: {},
    editableFields: {client: false, contract: false, guarantors: false, tenants: false, guarantor: [], tenant: []},
    property: null,
    client: {},
    uploadFile: false,
    paymentAmount: 0.0,
    reason: null,
    paymentLoading: false,
    paymentType: null,
    isPaid: false,
    paymentDate: null,
    minDate: new Date().toISOString().split('T')[0],
    dialogs: {sms: false, payment: false},
    newHistory: {note: "", status: "", step: 0, visibleToClient: true, visibleToOwner: true},
  }),
  created() {
    this.id = this.$route.params.id;
    this.refresh();
  },
  computed: {
    ...mapGetters('data', ['getUserFullName', 'getRealEstatesWebSite']),
    ...mapGetters('realEstateContracts', ['fileTags']),
    isAccessDenied() {
      return !!(this.contract && this.contract.denyLockerAccess === true);
    },
    currentStatusLabel() {
      switch (this.currentStatus) {
        case 'connected': return this.msg('Connected');
        case 'error': return this.msg('Offline / Error');
        case 'checking': return this.msg('Checking...');
        default: return this.msg('Unknown');
      }
    },
    currentStatusVariant() {
      switch (this.currentStatus) {
        case 'connected': return 'success';
        case 'error': return 'danger';
        case 'checking': return 'warning';
        default: return 'dark';
      }
    },
    currentStatusIcon() {
      switch (this.currentStatus) {
        case 'connected': return 'fas fa-check-circle text-success';
        case 'error': return 'fas fa-exclamation-triangle text-danger';
        case 'checking': return 'fas fa-sync-alt fa-spin text-warning';
        default: return 'fas fa-question-circle text-dark';
      }
    },
    paymentOptions() {
      return [
        {label: this.msg('Credit Card'), value: 'Credit card'},
        {label: this.msg('Cash'), value: 'Cash'},
        {label: this.msg('Wire Transfer'), value: 'Wire transfer'}
      ];
    },
    computedDeposit: {
      get() { return this.contractEdit.deposit != null && this.contractEdit.deposit > 0 ? this.contractEdit.deposit : this.property.realEstatePrices.deposit; },
      set(value) { if (this.contractEdit.deposit != null && this.contractEdit.deposit > 0) { this.contractEdit.deposit = value; } else { this.property.realEstatePrices.deposit = value; } }
    },
    statusData() {
      let statusMap = this.allContractStatus.map(status => ({...status, variant: this.allContractSteps[status.step].variant, animated: this.allContractSteps[status.step].animated})).toObject("name");
      statusMap["APPROVED_OWNER_CHANGES"].variant = "success";
      statusMap["REJECTED_OWNER_CHANGES"].variant = "danger";
      statusMap["APPROVED_CLIENT_SIGNATURE"].variant = "success";
      statusMap["REJECTED_CLIENT_SIGNATURE"].variant = "danger";
      statusMap["CANCELED"].variant = "danger";
      return (status) => ({...(statusMap[status] ? statusMap[status] : statusMap["NEW"]), value: status});
    },
    canEdit() {
      if (this.contract == null || this.contract.status == null) return false;
      return ["REVIEWING", "WAITING_FOR_DATA", "WAITING_FOR_FILE", "COMPLETED", "CANCELED"].indexOf(this.contract.status) >= 0
    },
    dropzoneOptions() {
      if (this.contract == null || this.contract.id == null) return {};
      return {
        url: window.config.apiUrl + 'realEstate/contract/upload/file/' + this.contract.id,
        headers: {'Authorization': `Bearer ${localStorage.Bearer}`},
        createImageThumbnails: false, thumbnailWidth: 200, thumbnailHeight: 200,
        addRemoveLinks: true, maxFilesize: 50000,
        acceptedFiles: "image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx",
      }
    },
    progress() {
      if (this.contract == null) return 0;
      let keys = Object.keys(this.progressByKey);
      if (keys.length === 0) return 100;
      let sum = Object.values(this.progressByKey).reduce((acc, val) => acc + val, 0);
      return sum / (keys.length);
    },
    progressByKey() {
      if (this.contract == null || this.$refs.alertComponent.alerts == null || this.$refs.alertComponent.alerts.length === 0)
        return { "contract": 100, "deposit": 100, "passport": 100, "signature": this.contract.signedOffer ? 100 : 0 };
      return {
        "contract": this.$refs.alertComponent.alerts.filter(a => a.actionRequired === "RENT_PAYMENT").length > 0 ? 0 : 100,
        "deposit": this.$refs.alertComponent.alerts.filter(a => a.actionRequired === "AUTHORIZATION_FEE_PAYMENT").length > 0 ? 0 : 100,
        "passport": this.$refs.alertComponent.alerts.filter(a => a.actionRequired === "UPLOAD_REQUIRED_FILES").length > 0 ? 0 : 100,
        "signature": this.contract.signedOffer ? 100 : 0,
      }
    },
    variantColorByProgress() {
      return { 100: 'success', 75: 'warning', 50: 'warning', 25: 'danger', 0: 'danger' };
    },
    imageSrc() {
      if (this.property.attachments == null || this.property.attachments[0] == null) return null
      if (this.property.attachments[0].attachmentUrl.startsWith('http')) return this.property.attachments[0].attachmentUrl
      return this.getRealEstatesWebSite + this.property.attachments[0].attachmentUrl;
    },
    currentStatus() {
      let $this = this;
      return this.allContractStatus.find(s => s.name === $this.contract.status) || {step: 0};
    },
    contractsStatus() {
      let $this = this;
      return this.allContractStatus.filter(status => status.step === this.newHistory.step).map(s => ({label: $this.msg(s.name), value: s.name, active: true}));
    },
    contractSteps() {
      let currentStep = this.allContractSteps[this.currentStatus.step];
      if (currentStep == null) return [];
      return Object.values(this.allContractSteps).map(step => ({...step, active: currentStep.value <= step.value || currentStep.name === "BLOCKED"}));
    },
    ksvStatus() {
      return [{label: this.msg("Application in progress"), value: "APPLICATIONCREATED"}, {label: this.msg("Done"), value: "DONE"}]
    },
  },
  methods: {
    ...mapActions("realEstateContracts", ["createPdfInvoiceContract", "getById", "depositWasPaid", "depositWasRefunded", "updateContract", "sproofRequest", "cancelContract", "changeContract", "updateStatus", "updateFilesData", "updateApproveStatus", "changeContractOwner", "updateEditableFields", "updateDocumentFile", "generateAndSendLink", "sendCheckInDetails", "getMonetaryId", "getCleaningId"]),
    ...mapActions("document", ["downloadFile"]),
    ...mapActions("monetary", ["chargeCustomer"]),
    ...mapActions("ksv", ["createOrFetchKsv", "getKsvById"]),
    ...mapActions("clients", ["generateToken"]),
    ...mapActions("keybox", ["openSlotFromContract","toggleLockerAccess","checkStatusLockerContract"]),
    openLocker() {
      this.currentStatus = 'checking';
      this.openSlotFromContract({ contractId: this.contract.id }).then(() => {
        this.currentStatus = 'connected';
        this.$bvToast.toast(this.msg('Locker opened successfully'), { variant: 'success', solid: true, autoHideDelay: 2500 });
        this.refreshLockerStatus();
      })
    },
    refreshLockerStatus() {
      this.currentStatus = 'checking';
      this.checkStatusLockerContract({ contractId: this.contract.id }).then(ans => {
        this.keyBoxStatus = ans;
        const msg = (ans.msg || '').toLowerCase();
        if (msg.includes('offline') || msg.includes('error')) { this.currentStatus = 'error'; } else { this.currentStatus = 'connected'; }
        if (ans.data) { this.contract.lockerStatus = ans; }
      }).catch(() => { this.currentStatus = 'error'; });
    },
    toggleAccess(action) {
      this.toggleLockerAccess({ contractId: this.contract.id, action: action }).then(updatedContract => { this.contract = updatedContract; })
    },
    openOverlappedBookingsModal() { this.$bvModal.show("overlappedBookingsModal"); },
    goToContract(id) { window.open(`/real_estate/contracts/rent/${id}`, '_blank'); },
    depositRefunded(label, value) { this.depositWasRefunded({id: this.contract.id, depositRefunded: value}); },
    depositPaid(label, value) { this.depositWasPaid({id: this.contract.id, depositPaid: value}); },
    resetCancelModal() { this.cancelModal.show = false; },
    resetChangeModal() { this.changeModal.show = false; this.newPropertyId = null; },
    resetPdfModal() { this.pdfModal.show = false; },
    cancelContractById() { this.cancelContract({id: this.contract.id}).then(() => { this.refresh(); }) },
    openInvoicePage() { this.getMonetaryId({id: this.contract.id}).then(monetaryId => { window.open(`/report/monetary/invoice/${monetaryId}`, '_blank'); }) },
    openCleaningProgressPage() { this.getCleaningId({id: this.contract.id}).then(cleaningId => { if (cleaningId != null) window.open(`/cleaning/edit/${cleaningId}`, '_blank'); else { this.$toast.error("Cleaning task not created yet") } }) },
    changeContractById() { this.changeContract({id: this.contract.id, propertyId: this.newPropertyId, hostawayApi: this.hostawayApi}).then(contractid => { if (!this.hostawayApi) this.$router.push(`/real_estate/contracts/rent/${contractid}`); else this.$router.push(`/real_estate/contracts/rent`); }) },
    toggleText() { this.showFullText = !this.showFullText; },
    generatePdfInvoice() { this.createPdfInvoiceContract(this.contract.id).then(console.log("PDF generated")) },
    openCancelModal() { this.cancelModal.show = true; },
    openChangeModal() { this.changeModal.show = true; },
    openPdfModal() { this.pdfModal.show = true; },
    refresh() { this.getById(this.id).then(this.onContractReceive, this.onContractRetrieveError); },
    createOrFetchKsvData() { this.createOrFetchKsv(this.id).then(ans => this.ksv = ans["Ksv"]); },
    onContractReceive(data) {
      let $this = this;
      this.buildApproveData(data.contract);
      this.buildEditableFieldsData(data.contract);
      this.contract = data.contract;
      this.contract.messageTemplateHistory = [...data.contract.messageTemplateHistory];
      this.contract.statusHistories = this.contract.statusHistories.sort((a, b) => $this.$moment(b.time, 'YYYY-MM-DD HH:mm:ss').diff($this.$moment(a.time, 'YYYY-MM-DD HH:mm:ss')))
      this.newHistory.status = this.contract.status;
      this.setContractEdit();
      this.property = data.property;
      this.client = data.client;
      this.permissions = data.permissions;
      this.allContractStatus = data.statuses;
      this.mergeSteps(data.steps);
      this.newHistory.step = this.allContractSteps[this.currentStatus.step].value;
      if (this.contract.ksvId != null) { this.getKsvById(this.contract.ksvId).then(ans => { $this.ksv = ans; }); }
    },
    buildApproveData(contract) {
      let approve = { contract: {client: false, property: false, contractData: false}, document: {document: false, income: false, photo: false, contract: false}, guarantors: {verified: false}, tenants: {verified: false} }
      if (contract.approve == null) { this.approve = approve; return contract.approve = approve; }
      contract.approve.contract = {...approve.contract, ...(contract.approve.contract || {})}
      contract.approve.document = {...approve.document, ...(contract.approve.document || {})}
      contract.approve.guarantors = {...approve.guarantors, ...(contract.approve.guarantors || {})}
      contract.approve.tenants = {...approve.tenants, ...(contract.approve.tenants || {})}
      this.approve = {...contract.approve};
    },
    buildEditableFieldsData(contract) {
      let editableFields = { client: false, contract: false, guarantors: false, tenants: false, guarantor: [false, false, false, false], tenant: [false, false, false, false] };
      this.editableFields = {...editableFields, ...(contract.editableFields || {})}
    },
    setContractEdit() {
      this.contractEdit.appointment = this.contract.appointment; this.contractEdit.moveDate = this.contract.moveDate; this.contractEdit.endDate = this.contract.endDate; this.contractEdit.numberOfGuests = this.contract.numberOfGuests;
      this.contractEdit.smart = this.contract.smart; this.contractEdit.insurance = this.contract.insurance; this.contractEdit.gas = this.contract.gas; this.contractEdit.internet = this.contract.internet;
      this.contractEdit.price = this.contract.price; this.contractEdit.provision = this.contract.provision; this.contractEdit.income = this.contract.income; this.contractEdit.bank = this.contract.bank;
      this.contractEdit.card = this.contract.card; this.contractEdit.deposit = this.contract.deposit; this.contractEdit.depositPaid = this.contract.depositPaid; this.contractEdit.depositRefunded = this.contract.depositRefunded;
      this.contractEdit.client = this.contract.client;
      if (this.contract.landlord != null) this.contractEdit.landlord = this.contract.landlord
      if (this.contract.bnbStyleRent != null) this.contractEdit.bnbStyleRent = this.contract.bnbStyleRent
    },
    mergeSteps(steps) {
      let defaultSteps = { 0: {name:"START",value:0,icon:"far fa-flag",variant:"info",animated:false}, 1: {name:"REVIEW",value:1,icon:"fas fa-list-ul",variant:"info",animated:true}, 2: {name:"OWNER_REVIEW",value:2,icon:"fas fa-user-tie",variant:"warning",animated:true}, 3: {name:"OWNER_SIGNED",value:3,icon:"fas fa-file-signature",variant:"success",animated:true}, 4: {name:"WAIT_CLIENT_SIGN",value:4,icon:"far fa-user",variant:"warning",animated:true}, 5: {name:"CLIENT_SIGNED",value:5,icon:"fas fa-signature",variant:"success",animated:true}, 7: {name:"BLOCKED",value:7,icon:"fas fa-ban",variant:"danger",animated:false}, 8: {name:"COMPLETED",value:8,icon:"far fa-check-circle",variant:"success",animated:false}, 10: {name:"FINALIZED",value:10,icon:"fas fa-check-double",variant:"success",animated:false} }
      this.allContractSteps = {...steps.toObject("value"), ...defaultSteps}
    },
    generateAndSendLinkButton() { this.generateAndSendLink(this.id); },
    sendCheckInDetailsButton() { this.sendCheckInDetails(this.id); },
    onContractRetrieveError(error) {},
    iconByExt(file) {
      if (file == null) return {fas: true, 'fa-file-alt': true};
      let ext = file.substr(file.lastIndexOf('.') + 1)
      if (ext === 'pdf') return {far: true, 'fa-file-pdf': true}
      if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gift' || ext === 'bmp') return {far: true, ' fa-file-image': true}
      if (ext === 'doc' || ext === 'docx') return {far: true, ' fa-file-word': true}
      if (ext === 'xls' || ext === 'xlsx') return {far: true, ' fa-file-word': true}
      if (ext === 'zip' || ext === 'rar' || ext === '7zip') return {far: true, ' fa-file-archive': true}
      return {fas: true, 'fa-file-alt': true}
    },
    resetNewHistory() { this.newHistory = {...this.newHistory, note: "", status: this.contract.status, step: this.allContractSteps[this.currentStatus.step].value} },
    uploadComplete(file, response) { let responseData = JSON.parse(file.xhr.responseText); this.contract.files = responseData.objects["documents"]; },
    uploadSuccess(file, response) { try { if (response.data == null || response.data['documents'] == null) return; this.contract.files = response.data['documents']; } catch (e) { console.error('uploadSuccess error', e) } },
    onStepChange() { if (this.contractsStatus.findIndex(status => status.value === this.newHistory.status) >= 0) return; this.newHistory.status = this.contractsStatus.find(status => status.active === true).value },
    openSmsDialog() { this.dialogs.sms = true },
    openPaymentModal() { this.dialogs.payment = true },
    makePayment() {
      let $this = this; this.paymentLoading = true
      this.chargeCustomer({contractId: this.contract.id, amount: this.paymentAmount, reason: this.reason, type: this.paymentType, paid: this.isPaid, date: this.paymentDate}).then(approve => { $this.dialogs.payment = false }).finally(() => { $this.paymentLoading = false; $this.paymentAmount = 0.0; $this.reason = null; $this.paymentType = null; $this.isPaid = false; $this.paymentDate = null; $this.dialogs.payment = false; $this.refresh(); })
    },
    submitContract() {
      if (this.contract.bnbStyleRent != null && this.contract.bnbStyleRent.active) this.contractEdit.bnbStyleRent = this.contract.bnbStyleRent
      this.contractEdit.income = this.contract.income; this.contractEdit.bank = this.contract.bank; this.contractEdit.card = this.contract.card; this.contractEdit.client = this.contract.client;
      this.updateContract({id: this.contract.id, contract: this.contractEdit}).then(contract => {
        this.contract.moveDate = contract.moveDate; this.contract.endDate = contract.endDate; this.contract.smart = contract.smart; this.contract.insurance = contract.insurance; this.contract.gas = contract.gas; this.contract.internet = contract.internet; this.contract.price = contract.price; this.contract.provision = contract.provision;
        if (contract.landlord != null) this.contract.landlord = contract.landlord
        this.setContractEdit()
        if (contract.status !== this.contract.status) this.refresh();
      })
    },
    changeOwner() {
      this.changeContractOwner({id: this.contract.id, ownerId: this.contract.ownerId}).then(contract => {
        this.contract.moveDate = contract.moveDate; this.contract.endDate = contract.endDate; this.contract.smart = contract.smart; this.contract.insurance = contract.insurance; this.contract.gas = contract.gas; this.contract.internet = contract.internet; this.contract.price = contract.price; this.contract.provision = contract.provision;
        if (contract.landlord != null) this.contract.landlord = contract.landlord; this.setContractEdit(); if (contract.status !== this.contract.status) this.refresh();
      })
    },
    submitDocumentsData() { this.updateFilesData({id: this.contract.id, contract: this.contract}).then(contract => { this.setContractEdit(); if (contract.status !== this.contract.status) this.refresh(); }) },
    submitStatus() { let $this = this; this.updateStatus({id: this.contract.id, status: this.newHistory}).then(history => { $this.contract.statusHistories = history.sort((a, b) => $this.$moment(b.time, 'YYYY-MM-DD HH:mm:ss').diff($this.$moment(a.time, 'YYYY-MM-DD HH:mm:ss'))); $this.contract.status = $this.contract.statusHistories[0].status; $this.resetNewHistory(); }) },
    submitApproveStatus(e) { this.updateApproveStatus({id: this.contract.id, approveStatus: this.approve}).then(approve => { this.contract.approve = approve; this.buildApproveData(this.contract); }) },
    submitUpdateEditable() { this.updateEditableFields({id: this.contract.id, editableFields: this.editableFields}); },
    requestSigningTheOffer() { this.$refs['sign-offer'].requestSignContract() },
    onHideFile(index) { let file = this.contract.files[index]; file.visible = false; file.visibleForOwner = false; file.active = false; this.submitDocumentFile(index) },
    submitDocumentFile(index) { this.updateDocumentFile({id: this.contract.id, file: this.contract.files[index]}); },
    submitSMS() { this.$root.$emit('crm::submitSms') },
    onSubmitted(server) { this.dialogs.sms = false; },
    onDownloadFile(fileId) { this.downloadFile({fileId: fileId, clientId: this.contract.clientId}).then(file => { this.asyncDownloadFile(file) }) },
    openClientAccount() { this.generateToken(this.client.id).then(res => { window.open(res.details.sitePath, '_blank'); }) }
  }
}
</script>

<style lang="scss">
.rce-page {
  padding-bottom: 20px;
}

.rce-card {
  border-radius: 18px !important;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,.06) !important;
  box-shadow: 0 8px 22px rgba(0,0,0,.05) !important;
}

.rce-section-icon {
  width: 38px; height: 38px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; margin-right: 10px; flex-shrink: 0;
}
.rce-icon-purple { background: rgba(115,103,240,.12); color: #7367f0; }
.rce-icon-green { background: rgba(40,199,111,.12); color: #28c76f; }
.rce-icon-blue { background: rgba(0,123,255,.12); color: #007bff; }
.rce-icon-orange { background: rgba(255,159,67,.12); color: #ff9f43; }
.rce-icon-teal { background: rgba(0,184,148,.12); color: #00b894; }

.rce-section-title { font-weight: 900; font-size: 14px; letter-spacing: .3px; }

.rce-status-pill { font-weight: 700; font-size: 11px; padding: 6px 14px; }

.rce-progress { border-radius: 999px; }
.rce-progress .progress-bar { border-radius: 999px; }

.rce-progress-card {
  padding: 10px 14px; border-radius: 14px;
  border: 1px solid rgba(0,0,0,.06);
  background: rgba(0,0,0,.01);
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 8px;
}
.rce-progress-label { font-weight: 700; font-size: 12px; text-transform: capitalize; }

.rce-info-table { display: flex; flex-direction: column; gap: 0; }
.rce-info-row {
  display: flex; align-items: center; padding: 8px 0;
  border-bottom: 1px solid rgba(0,0,0,.04);
  &:last-child { border-bottom: none; }
}
.rce-info-key { font-size: 12px; font-weight: 700; opacity: .7; white-space: nowrap; min-width: 160px; flex-shrink: 0; }
.rce-info-val { font-size: 13px; flex: 1; min-width: 0; }

.rce-inline-input { border-radius: 10px !important; }

.rce-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; opacity: .65; }

.rce-select .vs__dropdown-toggle { border-radius: 10px; }

.rce-btn-sm { border-radius: 12px; font-weight: 700; font-size: 12px; }
.rce-icon-btn { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; border-radius: 10px; padding: 0; }

.rce-approve-check { font-size: 12px; font-weight: 600; }

.rce-action-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.rce-action-btn { border-radius: 12px; font-weight: 700; font-size: 11px; white-space: nowrap; }

.rce-read-more { color: #7367f0; cursor: pointer; font-size: 12px; font-weight: 600; }
.rce-read-more:hover { text-decoration: underline; }

.rce-overlap-list { list-style: none; padding: 0; margin: 0; }
.rce-overlap-item { padding: 12px; border-radius: 12px; border: 1px solid rgba(0,0,0,.08); background: rgba(0,0,0,.01); margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between; }

.rce-file-warning { border-radius: 12px; font-size: 12px; }

.rce-files-table { font-size: 12px; }
.rce-files-table th { font-size: 11px; font-weight: 800; text-transform: uppercase; text-align: center; }

.max-lines-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

.files-data {
  position: relative; height: 300px;
  > .upload-backdrop {
    position: absolute; width: 100%; height: 100%; z-index: 9999;
    .dropzone-custom-content { margin-top: 110px }
  }
}
</style>
